import { render, staticRenderFns } from "./classroomManagement.vue?vue&type=template&id=bf66d2ba&"
import script from "./classroomManagement.vue?vue&type=script&lang=js&"
export * from "./classroomManagement.vue?vue&type=script&lang=js&"
import style0 from "./classroomManagement.vue?vue&type=style&index=0&id=bf66d2ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports